const CourseDetails = [
  {
    id: 1,
    courseTitle: "Data Structures and Algorithms",
    content:
      "This introductory course provides a comprehensive foundation in data structures and algorithms, which are fundamental to computer science and programming.",
    popupContents: {
      mainContent:
        "A data structure is a way of organising and storing data in a computer's memory so that it can be used efficiently. It defines the relationship between data and the operations that can be performed on the data. Common data structures include arrays, linked lists, stacks, queues, trees, and graphs.An algorithm is a step-by-step procedure or set of rules for solving a specific problem or accomplishing a particular task. It provides a clear and unambiguous description of how to perform a computation or solve a problem. Algorithms are independent of programming languages and are essential for writing efficient and effective computer programs",
      basicPoints: {
        p1: "Linear & Non-Linear Data structures",
        p2: "Search & Sort Algorithms",
      },
      advPoints: {
        p1: "Hashed Data Structures",
        p2: "Graph Algorithms",
      },
    },
  },
  {
    id: 2,
    courseTitle: "C and C++",
    content:
      "This introductory course provides a solid foundation in the C programming language, covering basic concepts, syntax, and programming techniques.",
    popupContents: {
      mainContent:
        "C is a general-purpose programming language that was created by Dennis Ritchie at Bell Labs in the early 1970s. It is one of the most influential and widely used programming languages.C++ is an extension of the C programming language with additional features, primarily designed by Bjarne Stroustrup in the early 1980s. It combines procedural programming with object-oriented programming (OOP) features.    ",
      basicPoints: {
        p1: "Procedural Programming",
        p2: "Low-Level Manipulation",
      },
      advPoints: {
        p1: "	Application Development",
        p2: "Higher-Level Abstractions",
      },
    },
  },
  {
    id: 3,
    courseTitle: "Python MySQL Package",
    content:
      "This comprehensive course is designed to equip students with the knowledge and skills to develop Python applications that seamlessly interact with MySQL databases",
    popupContents: {
      mainContent:
        "Python programming is a versatile and popular programming language that is widely used for data exploration and analysis. With its simple syntax and extensive libraries, Python makes it easy to work with and manipulate data.Python provides powerful libraries such as NumPy and pandas, which allow you to efficiently manipulate and analyze data. NumPy provides support for large, multi-dimensional arrays and a wide range of mathematical functions, while pandas offers data structures and tools for data manipulation, cleaning, and analysis.",
      basicPoints: {
        p1: "Data Analysis",
        p2: "Machine Learning",
      },
      advPoints: {
        p1: "Web Development",
        p2: "Data Visualization",
      },
    },
  },
  {
    id: 4,
    courseTitle: "Java MySQL Package",
    content:
      "This course provides a solid foundation in both Java programming and MySQL database management.",
    popupContents: {
      mainContent:
        "Java is a versatile programming language that is widely used for developing various types of software, including web applications. It offers a robust set of libraries and frameworks that make it easier to work with databases like MySQL. MySQL is a popular open-source relational database management system. It provides a secure and scalable solution for storing and retrieving data. With Java, you can establish a connection to a MySQL database and perform various operations such as querying, inserting, updating, and deleting data.To interact with MySQL using Java, you can utilize the JDBC (Java Database Connectivity) API.",
      basicPoints: {
        p1: "Web Development",
        p2: "Big Data Processing",
      },
      advPoints: {
        p1: "Mobile App Development",
        p2: "Desktop Applications",
      },
    },
  },
  {
    id: 5,
    courseTitle: "Java React Fullstack",
    content:
      "A Java React Fullstack course typically covers both the Java programming language for backend development and the React JavaScript library for frontend development",
    popupContents: {
      mainContent:
        "Java is a high-level, object-oriented programming language developed by James Gosling and his team at Sun Microsystems in the mid-1990s. It is designed to be platform-independent, meaning Java programs can run on any device or operating system that has a Java Virtual Machine (JVM) installed.React, also known as React.js or ReactJS, is an open-source JavaScript library developed and maintained by Facebook. It is widely used for building user interfaces (UI) in web applications. React is particularly well-suited for creating single-page applications (SPAs) where dynamic content is frequently updated.Full stack refers to the development of both the frontend (client-side) and the backend (server-side) of a web application. A full stack developer is someone who possesses the skills and knowledge to work on both the frontend and backend aspects of a software system.",
      basicPoints: {
        p1: "Advanced java",
        p2: "Springboot Framework",
      },
      advPoints: {
        p1: "Core react",
        p2: "Integration with APIs",
      },
    },
  },
  {
    id: 6,
    courseTitle: "UI / UX",

    content:
      "This course provides a comprehensive introduction to the principles of user interface and user experience design.",
    popupContents: {
      mainContent:
        "UI -User Interface, refers to the point of interaction between a user and a digital device or software application. It encompasses all the elements and features that users interact with to accomplish tasks within a digital environment. The primary goal of UI design is to create an intuitive, visually appealing, and user-friendly interface that facilitates a seamless and enjoyable user experience.UX -User Experience (UX) refers to the overall experience that a user has when interacting with a product, service, or system, especially in the context of digital interfaces. It encompasses a user's emotions, perceptions, and responses before, during, and after using a product. The goal of UX design is to create a positive, seamless, and meaningful experience that meets the needs and expectations of the user.",
      basicPoints: {
        p1: "	Visual design",
        p2: "Responsive design",
      },
      advPoints: {
        p1: "User research",
        p2: "Interactive design",
      },
    },
  },
  {
    id: 7,
    courseTitle: ".NET (MVC)",

    content:
      "This beginner-level course provides a comprehensive introduction to the .NET framework, including its history and components.",
    popupContents: {
      mainContent:
        "NET MVC (Model-View-Controller) is a powerful framework for building web applications. It provides a structured approach to development, separating the application into three main components: the model, which represents the data and business logic; the view, which handles the user interface; and the controller, which manages the flow of data between the model and the view. With .NET MVC, developers can create scalable and maintainable web applications, leveraging the robust features and libraries provided by the .NET framework. It offers flexibility, testability, and extensibility, making it a popular choice for building modern and dynamic web applications.",
      basicPoints: {
        p1: "MVC Patterns",
        p2: "Routing",
      },
      advPoints: {
        p1: "Validation",
        p2: "Web API",
      },
    },
  },
  {
    id: 8,
    courseTitle: "Web Designing",

    content:
      " This introductory course covers the fundamental principles of web design. Students will learn about layout, typography, color theory, and user interface design",
    popupContents: {
      mainContent:
        "Web designing is the process of planning, conceptualizing, and implementing the plan for designing a website in a way that is functional and offers a good user experience. User experience is central to the web designing process. Websites have an array of elements presented in ways that make them easy to navigate.",
      basicPoints: {
        p1: "Figma",
        p2: "Designing Tools",
      },
      advPoints: {
        p1: "HTML & CSS",
        p2: "Sketches and Designing Softwares",
      },
    },
  },
  {
    id: 9,
    courseTitle: "Ms Office",

    content:
      "This comprehensive Microsoft Word course is designed to help you become proficient in creating, formatting, and editing documents",
    popupContents: {
      mainContent:
        "Microsoft Office is a powerful suite of productivity tools that can greatly enhance your work efficiency. With Word, you can create professional documents with ease, whether it's a simple letter or a complex report. Excel allows you to analyze and organize data, making it a valuable tool for data-driven tasks. PowerPoint empowers you to create visually stunning presentations that captivate your audience. MS Office is a game-changer for professionals in all industries, offering a wide range of features to streamline your work and boost productivity.",
      basicPoints: {
        p1: "Word",
        p2: "Excel",
      },
      advPoints: {
        p1: "PowerPoint",
        p2: "Outlook",
      },
    },
  },
  {
    id: 10,
    courseTitle: "Tally ERP 9 including GST",

    content:
      "This comprehensive Microsoft Word course is designed to help you become proficient in creating, formatting, and editing documents",
    popupContents: {
      mainContent:
        "Tally ERP 9 permits business owners and their associates to interact more in accounts related discussions and is a complete product that retains its original simplicity yet offers comprehensive business functionalities such as Accounting, Finance, Inventory, Sales, Purchase, Point of Sales, Manufacturing, Costing, Job.",
      basicPoints: {
        p1: "Accounting",
        p2: "	Billing",
      },
      advPoints: {
        p1: "Taxation",
        p2: "Banking",
      },
    },
  },

  {
    id: 11,
    courseTitle: "Data Analysis and Advanced Microsoft Excel",
    content:
      "This course provides a foundational understanding of data analysis techniques and tools. You'll learn how to collect, clean, and analyze data using various methods and software",
    popupContents: {
      mainContent:
        "Data analysis is the process of inspecting, cleansing, transforming, and modeling data with the goal of discovering useful information, informing conclusions, and supporting decision-making.      Advanced knowledge of Excel means possessing the ability to use spreadsheets, graphing, tables, calculations, and automation efficiently to process large quantities of data relevant to business tasks.      ",
      basicPoints: {
        p1: "	Logical function",
        p2: "Data validation",
      },
      advPoints: {
        p1: "	Lookup function",
        p2: "Pivot tables",
      },
    },
  },

  {
    id: 12,
    courseTitle: "Data Analysis and Visualisation in Power Bi",

    content:
      "This course provides a comprehensive introduction to Power BI, a powerful data analysis and visualization tool. Learn to import, transform, and visualize data to make informed business decisions.",
    popupContents: {
      mainContent:
        "Power BI is a business analytics service provided by Microsoft that lets you visualize your data and share insights. It converts data from different sources to build interactive dashboards and Business Intelligence reports. As you see above, we have some sales data in an excel sheet.",
      basicPoints: {
        p1: "Introduction to power bi",
        p2: "Reports and dashboards",
      },
      advPoints: {
        p1: "Publishing workbook and workspace",
        p2: "Power bi reports servers",
      },
    },
  },
  {
    id: 13,
    courseTitle: "Python Programming and Data Exploration",
    content:
      "This course serves as a comprehensive introduction to Python, one of the most popular programming languages for data science and software development.",
    popupContents: {
      mainContent:
        "Data Structures and Algorithms (DSA) form the backbone of efficient and optimized computer programs. In the realm of data structures, key concepts include arrays, linked lists, stacks, and queues, each offering unique advantages in organizing and managing data.",
      basicPoints: {
        p1: "Basics of Data Structures",
        p2: "Linkedlist, Arraylist",
      },
      advPoints: {
        p1: "Calculating Algorithms",
        p2: "Sorting Algorithms",
      },
    },
  },
  {
    id: 14,
    courseTitle: "Social Media Marketing",
    content:
      "This course provides a foundational understanding of social media marketing strategies and techniques. Students will learn how to create, manage, and optimize social media profiles on platforms such as Facebook, Twitter, Instagram, and LinkedIn. ",
    popupContents: {
      mainContent:
        "Social media marketing (also known as digital marketing and e-marketing) is the use of social media—the platforms on which users build social networks and share information—to build a company's brand, increase sales, and drive website traffic. In addition to providing companies with a way to engage with existing customers and reach new ones, SMM has purpose-built data analytics that allows marketers to track the success of their efforts and identify even more ways to engage.",
      basicPoints: {
        p1: "Make Money as an Affiliate Marketer",
        p2: "Work From Home as a Freelance Marketer",
      },
      advPoints: {
        p1: "Get Hired as a Digital Marketing Expert",
        p2: "",
      },
    },
  },
  {
    id: 15,
    courseTitle: "SEO and SEM",
    content:
      "This comprehensive SEO course provides a solid foundation in understanding and implementing the key strategies and best practices for optimizing websites to rank higher in search engine results.",
    popupContents: {
      mainContent:
        "Seo - Search Engine Optimization, is a set of practices and techniques aimed at improving a website's visibility and ranking on search engines. The primary goal of SEO is to enhance the chances of a website appearing in search engine results when users search for relevant terms or keywords.Sem - Search Engine Marketing (SEM) is a digital marketing strategy that involves promoting websites by increasing their visibility on search engine results pages (SERPs) through paid advertising. SEM primarily encompasses paid search advertising, commonly known as Pay-Per-Click (PPC) advertising.",
      basicPoints: {
        p1: "On-page and Off-page seo",
        p2: "Technical seo",
      },
      advPoints: {
        p1: "Pay per click advertising",
        p2: "Mobile advertising",
      },
    },
  },
  {
    id: 16,
    courseTitle: "E-Mail Marketing",
    content:
      "This course provides a comprehensive introduction to the world of email marketing. You'll learn how to build and segment email lists, create engaging content, design eye-catching templates, and measure the effectiveness of your email campaigns",
    popupContents: {
      mainContent:
        "Email marketing is a powerful marketing channel, a form of direct marketing as well as digital marketing, that uses email to promote your business’s products or services. It can help make your customers aware of your latest items or offers by integrating it into your marketing automation efforts. It can also play a pivotal role in your marketing strategy with lead generation, brand awareness, building relationships or keeping customers engaged between purchases through different types of marketing emails",
      basicPoints: {
        p1: "Driving traffic through emails",
        p2: "Email campaigns",
      },
      advPoints: {
        p1: "Building email lists",
        p2: "Getting email subscribers",
      },
    },
  },
];

export default CourseDetails;
